module.exports = __webpack_public_path__ + "media/images/time-3d5cc46b66c2e0281e037d503d89f1d6.svg";